import Form from '.';
import { InputProps } from '../Input';

interface FormFieldProps extends InputProps {
  label?: string;
}

export default function FormField({
  children,
  label,
  className = '',
  ...rest
}: FormFieldProps) {
  return (
    <div className={`form-field ${className}`}>
      <Form.Input label={label} className={`form-field-input`} {...rest} />
      {children}
    </div>
  );
}
